class APIS {
	apis() {
		return {
			fetchSlider: {
				headers: {
					"xt-user-token": null,
				},
				method: "get",
				path: "/fetch/sliders/true",
			},
			fetchSlides: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/slides",
			},
			
			
		};
	}
}

export default new APIS();
